/**
 * Event-related strings.
 */
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icons from '../ui/IconButton/Icons';

const configIcon = <FontAwesomeIcon icon={Icons.CONFIG.reactIcon}/>;

export default {
    d_title: 'Deadlines and Events',
    h_title: '<div><p>This sections documents events related to the contact.</p><p>Events can include historical data, such as birthdays and wedding dates.</p><p>Events can also include legal dates, such as hearings and deadlines. All events in this section will show up on the <b>Task Calendar</b>.</p></div>',

    d_portal_title: 'Your Calendar',
	h_portal_title: 'Your upcoming deadlines, court dates and other case-related events are available here. You can also add other important dates here yourself.',

    d_event: 'Category',
    h_event: <div>
        <p>The category for this deadline or event. You can choose from a list of existing event types, or add your own.</p>
        <p>Use the {configIcon} Configure button to configure new categories.</p>
    </div>,

    d_description: 'Description',
    h_description: '<div><p>An optional description for this event.</p></div>',

	d_location: 'Location',
	h_location: '<div><p>Location of the Event</p></div>',

    d_date: 'Date',
    h_date: '<div><p>For a deadline, this is the date and time the deadline expires.</p><p>For an event, this is the date and/or time that this event occurred or is scheduled to occur.</p></div>',

    d_participants: 'Participants',
    h_participants: '<div><p>A list of people that were present at the event, or that you want to note as being part of the event.</p></div>'

};
